<thead>
    <tr>
        <td>Показатель</td>
        <td>Плановое значение</td>
        <td>Период сбора (1)</td>
        <td>Фактическое значение (1)</td>
        <td>Период сбора (2)</td>
        <td>Фактическое значение (2)</td>
        <td>Период сбора (3)</td>
        <td>Фактическое значение (3)</td>
        <td>Период сбора (4)</td>
        <td>Фактическое значение (4)</td>
        <td>Действия</td>
    </tr>
</thead>
